"use client"

import { motion } from "framer-motion"
import { AlertCircle, Clock, MessageSquare, TrendingDown } from "lucide-react"

export function ProblemSection() {
  return (
    <section className="py-20 px-6 bg-secondary">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="font-serif text-4xl md:text-5xl text-center mb-12 text-balance"
        >
          Знакомая ситуация?
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-12 text-justify"
        >
          <p className="text-muted-foreground leading-relaxed mb-4">
            Утро понедельника. Открываете Instagram — 47 новых сообщений накопилось за выходные. Начинаете отвечать:
          </p>
          <ul className="text-muted-foreground space-y-2 mb-4">
            <li>"Есть ли розовая сумка в наличии?" — проверяете склад</li>
            <li>"Какой размер кольца подойдет?" — копируете размерную сетку</li>
            <li>"Когда будет доставка в Москву?" — объясняете сроки</li>
            <li>"Можно больше фото?" — отправляете дополнительные снимки</li>
          </ul>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Через час ответили на 15 сообщений, пришло еще 12 новых. В 11:00 видите сообщение от утреннего клиента:{" "}
            <strong className="!text-black font-semibold">
              "Спасибо, но я уже заказала в другом магазине, они ответили быстрее."
            </strong>
          </p>
          <p className="text-muted-foreground leading-relaxed mb-6">
            К обеду отвечено 35 сообщений, но накопилось еще 25. Забываете пообедать. В 15:00 понимаете, что еще не
            выложили контент на сегодня, не обработали вчерашние заказы, не связались с поставщиком по новой коллекции.
            Но сообщения продолжают сыпаться.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Вечером в 21:00 все еще сидите в Instagram. Семья жалуется, что вы постоянно в телефоне. Засыпаете с мыслью,
            что завтра все повторится.
          </p>
        </motion.div>

        {/* Real Quotes */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="space-y-4 mb-12"
        >
          <div className="bg-background border border-border rounded-xl p-6 italic">
            <p className="text-muted-foreground mb-2">
              "Welcome to hell lol. Been doing this for 2 years and still manually replying to the same five questions
              every day."
            </p>
            <p className="text-sm text-muted-foreground">— Владелец fashion бренда на Reddit</p>
          </div>
          <div className="bg-background border border-border rounded-xl p-6 italic">
            <p className="text-muted-foreground mb-2">
              "I lose customers daily because I can't respond fast enough. They literally tell me they bought from
              competitors who replied instantly."
            </p>
            <p className="text-sm text-muted-foreground">— Основатель beauty бренда</p>
          </div>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4"
        >
          <div className="bg-background rounded-xl p-6 text-center">
            <Clock className="w-8 h-8 mx-auto mb-2 text-accent" />
            <div className="text-2xl font-bold mb-1">4+ часа</div>
            <div className="text-sm text-muted-foreground">в день на ответы</div>
          </div>
          <div className="bg-background rounded-xl p-6 text-center">
            <TrendingDown className="w-8 h-8 mx-auto mb-2 text-accent" />
            <div className="text-2xl font-bold mb-1">20-30%</div>
            <div className="text-sm text-muted-foreground">потерянных продаж</div>
          </div>
          <div className="bg-background rounded-xl p-6 text-center">
            <MessageSquare className="w-8 h-8 mx-auto mb-2 text-accent" />
            <div className="text-2xl font-bold mb-1">60-100</div>
            <div className="text-sm text-muted-foreground">сообщений в день</div>
          </div>
          <div className="bg-background rounded-xl p-6 text-center">
            <AlertCircle className="w-8 h-8 mx-auto mb-2 text-accent" />
            <div className="text-2xl font-bold mb-1">74%</div>
            <div className="text-sm text-muted-foreground">задают вопросы перед покупкой</div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
